module.exports = "<div class=row>\n    <div class=col-xs-12>\n        <div class=liste></div>\n    </div>\n</div>";